export default __webpack_public_path__ + "static/media/closet5-after1-1024w.20372d2d.webp";